import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Collage from '../components/Collage';
import { doSetPassword } from '../actions';
import t from 'tcomb-form';

var Password = t.refinement(t.String, (s) => (s.length >= 6));

function samePasswords(x) {
  return x.password1 === x.password2;
}

var FormSchema = t.subtype(t.struct({
  password1: Password,
  password2: Password
}), samePasswords);

const options = {
  error: 'Passwords must match',
  fields: {
    password1: {
      label: "Password",
      type: 'password',
      error: 'Invalid password, enter at least 6 chars'
    },
    password2: {
      label: 'Password confirmation',
      type: 'password',
      error: 'Invalid password, enter at least 6 chars'
    }
  }
};



class ForgotPassword extends Component {

  constructor(props) {
    super();
    this.state = {
      value: {}
    };
  }

  componentWillMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }

  }

  handleSubmit(e) {
    e.preventDefault();
    var value = this.refs.form.getValue();
    if (value) {
      this.props.doSetPassword({
        password: value.password1,
        uid: this.props.params.uid,
        token: this.props.params.token,
      })
    }
  }

  onChange(value) {
    this.setState({value});
  }

  render() {

    return (
      <div className="forgot-content">
        <Collage />

        <div className="forgot-wrapper">
          <div className="forgot-title">Set new password</div>
          <span>Enter your new password twice</span>
          <form className="forgot-form" onSubmit={this.handleSubmit.bind(this)}>
            <t.form.Form
              ref="form"
              type={FormSchema}
              options={options}
              value={this.state.value}
              onChange={this.onChange.bind(this)}
            />
            <input className="button button-primary" onClick={this.handleSubmit.bind(this)} type="submit" value="Set my new password"/>
          </form>
        </div>
      </div>
    );
  }

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doSetPassword,
  }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.jsx